import { createFileRoute, notFound } from '@tanstack/react-router'
import StateScamPage from '@/components/StateScamPage'
import { getStateRow, slugToCode } from '@/lib/ic3'
import { getScamTypeBySlug } from '@/scams'
import { usePageSeo } from '@/lib/page-seo'

export const Route = createFileRoute('/states/$slug/scams/$scamSlug')({
  beforeLoad: ({ params }) => {
    const code = slugToCode(params.slug)
    const scam = getScamTypeBySlug(params.scamSlug)
    if (!code || !scam) throw notFound()
  },
  component: StateScamRoute,
})

function StateScamRoute() {
  const { slug, scamSlug } = Route.useParams()
  const code = slugToCode(slug) ?? ''
  const scam = getScamTypeBySlug(scamSlug)
  const stateName = getStateRow(code)?.name ?? code
  usePageSeo(
    scam
      ? {
          title: `${scam.name} in ${stateName} · ScamDefense`,
          description: `${scam.tagline} How this scam plays out in ${stateName}, the warning signs, and what to do if it reaches you.`,
          canonicalPath: `/states/${slug}/scams/${scamSlug}`,
        }
      : null,
  )
  if (!scam) return null
  return <StateScamPage code={code} scam={scam} />
}
